const multipleNodes = (query, callback) => {
  const nodes = document.querySelectorAll(query);

  for (var i = 0; i < nodes.length; i++) {
    callback(nodes[i]);
  }
};

export default multipleNodes;
